<template id="flow-template">
  <div class="homeview-realtime-data">
    <div class="flowCircleOne">
      <div class="circle-chart">
        <div
          class="task-item"
          v-bind:class="{ item2: index == 0, item4: index == 1 }"
          v-for="(item, index) in realtimeData"
          :key="index"
        >
          <div class="task-icon-wrapper">
            {{ item.total }}
            <div class="task-icon"></div>
          </div>
          <div class="task-status">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!-- 车位显示 -->
    <div style="width: 100%; height: 75%">
      <!-- 车位表格 table-chart-->
      <div class="table_box">
        <el-table
          :data="tableData"
          border
          style="width: 94%; margin: 0 auto"
          fixed
        >
          <el-table-column
            prop="Name"
            label="设备名称"
            width=""
          ></el-table-column>
          <el-table-column prop="Type" label="终端类型"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import GetIpApi, {
  getUserIP,
  getNetworkIp,
} from "../../../../../../websoket/GetIp";
import WebSocketApi from "../../../../../../websoket/intercomWebsocket";
//import { getLocalIp } from "../../../../../../request/localproxyhttp";
import { findLatestPage } from "../../../../../../request/analysisApi";
const strNumber = global.$config.api.strNumber;
const strPassword = global.$config.api.strPassword;
const strLocalIP = global.$config.api.strLocalIP;
const strServer = global.$config.api.strServer;

export default {
  name: "HomeViewPeople",
  componentName: "HomeViewPeople",
  components: {},
  props: {},
  data() {
    return {
      realtimeData: [
        //     {
        //     name: "通讯设备",
        //     total: 0
        // },
        {
          name: "在线",
          total: 0,
        },
      ],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      LoginSend: {
        strNumber: strNumber,
        strPassword: strPassword,
        strLocalIP: strLocalIP,
        strServer: strServer,
      },
      ws: null,
      InitTimer: "",
      EquipDataTimer: "",
      TimerCount: 0,
      EquipTimerCount: 0,
      Ip: "",
      href: "/lib/proxy/LocalproxySetup.zip",
      hrefimg: "/lib/proxy/localproxy.png",
      href2: "/lib/proxy/IPDispatcherProxy_setup.zip",
      href2img: "/lib/proxy/IPDispatcherProxy.png",
      deptArray: [] /*用户部门列表*/,
      userStateArray: [] /*用户状态列表*/,
      //声明一个变量来注册监听事件
      getSocketData: null,
      subscribersArray: [] /*用户列表*/,
    };
  },
  created() {},
  mounted() {
    let that = this;
    //  this.getInfo();
    // setInterval(function () {
    //   that.getInfo();
    // }, 30000);
    // getLocalIp()
    //   .then((r) => {
    //     if (r.State == 0) {
    //       console.log("获取本地ip", r);
    //       this.LoginSend.strLocalIP = r.ip; //"192.168.43.141"
    //       /*r.ip;*/
    //       console.log("LoginSend", this.LoginSend);
    //       this.InitWebSocket();
    //       this.initTime();
    //     } else {
    //       this.$alert(
    //         `本地代理异常，请检查本地代理是否安装并运行！<br/><img src=${this.hrefimg} style='width:20px;height:20px'/><a href=${this.href} type="primary" download="LocalproxySetup.zip" style='color:#4194fc'>下载地址</a>`,
    //         "本地代理异常",
    //         {
    //           dangerouslyUseHTMLString: true,
    //         }
    //       );
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);

    //     this.$alert(
    //       `本地代理异常，请检查本地代理是否安装并运行！<br/><img src=${this.hrefimg} style='width:20px;height:20px'/><a href=${this.href} type="primary" download="LocalproxySetup.zip" style='color:#4194fc'>下载地址</a>`,
    //       "本地代理异常",
    //       {
    //         dangerouslyUseHTMLString: true,
    //       }
    //     );
    //   });

    this.InitWebSocket();
    this.initTime();
    this.getSocketMessage();
  },
  methods: {
    getSocketMessage() {
      // 创建接收消息函数
      this.getSocketData = (e) => {
        let msgdat = e && e.detail.data;
        //这边编写处理服务端消息代码
        if (msgdat) {
          if (msgdat.indexOf("AllSubscribers") != -1) {
            console.log("获取所有用户成功");
            var myobj = JSON.parse(msgdat);
            this.subscribersArray = myobj.AllSubscribers;
            this.getAllSubscribers();
          }

          /*得到某个用户的状态改变事件*/
          if (msgdat.indexOf("OnSubscriberStatusChanged") != -1) {
            // document.getElementById("TextArea2").value += msgdat + "\n";

            var myobj = JSON.parse(msgdat);

            this.StatisticsUser();
            return;
          }
          var arrInfo = msgdat.split(":");

          if (arrInfo.length == 2) {
            if (arrInfo[0] == "OnErrorMessage") {
              this.getErrInfo(arrInfo[1]);
            }
          }
        }
      };
      //注册监听事件
      window.addEventListener("onmessageWS", this.getSocketData);
      if (WebSocketApi.GetErrorMsg()) {
        this.$message({
          type: "error",
          message: WebSocketApi.GetErrorMsg(),
        });
      }
    },
    getInfo() {
      let that = this;
      let params = {
        page: 1,
        size: 999,
      };
      findLatestPage(params)
        .then((r) => {
          if (r.code == 0) {
            let data = r.data;
            data.forEach((item) => {
              let poi = item.poiBd.split(",");
              item.longitude = poi[0];
              item.latitude = poi[1];
            });
            that.tableData = data;
            that.$emit("connect", data);
            that.realtimeData[0].total = r.count;
          } else {
            that.tableData = r.data;
            that.$emit("connect", []);
            this.$message({
              type: "error",
              message: r.msg,
            });
          }
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: r.msg,
          });
        });
    },
    initTime() {
      /*时间处理*/
      this.InitTimer = setInterval(this.InitConnect, 1000);
    },
    InitWebSocket() {
      this.ws = WebSocketApi.OpenWebsoket(this.LoginSend);
    },
    getErrInfo(status) {
      let statusName = WebSocketApi.GetErrcodeString(status);
      if (statusName) {
        this.$message({
          type: "error",
          message: statusName,
        });
      }
    },
    InitConnect() {
      let that = this;
      if (this.TimerCount++ > 5) {
        // that.$message({
        //   type: "error",
        //   message: "话机注册超时",
        // });
        // this.$alert(
        //   `话机注册超时，请检查调度代理控件是否安装并运行！<br/><img src=${this.href2img} style='width:20px;height:20px'/><a href=${this.href2} type="primary" download="IPDispatcherProxy_setup.zip" style='color:#4194fc'>下载地址</a>`,
        //   "话机注册超时",
        //   {
        //     dangerouslyUseHTMLString: true,
        //   }
        // );
        this.TimerCount = 0;
        clearInterval(this.InitTimer);
        return;
      }
      var ConnectState = WebSocketApi.GetConnectState();
      if (ConnectState == "Success") {
        var LoginState = WebSocketApi.GetLoginState();
        if (LoginState == "Success") {
          that.$message({
            type: "success",
            message: "融合通讯登录成功",
          });
          this.searchEquipData();
          this.searchGroupData();
          this.searchPttGroupList();
          this.TimerCount = 0;
          clearInterval(this.InitTimer);
        } else if (LoginState == "Fail") {
          // that.$message({
          //   type: "error",
          //   message: "话机注册失败",
          // });
          this.TimerCount = 0;
          clearInterval(this.InitTimer);
        }
      } else if (ConnectState == "Fail") {
        // that.$message({
        //   type: "error",
        //   message: "对讲机服务器连接失败",
        // });
        this.$alert(
          `对讲机服务器连接失败，请检查调度代理控件是否安装并运行！<br/><img src=${this.href2img} style='width:20px;height:20px'/><a href=${this.href2} type="primary" download="IPDispatcherProxy_setup.zip" style='color:#4194fc'>下载地址</a>`,
          "对讲机服务器连接失败",
          {
            dangerouslyUseHTMLString: true,
          }
        );
        this.TimerCount = 0;
        clearInterval(this.InitTimer);
      }
    },

    searchEquipData() {
      WebSocketApi.SendAllSubscribers();
      // WebSocketApi.SendAllSubscriberStatusList();
      //  this.EquipDataTimer = setInterval(this.GetEquipData, 1000);
    },
    GetEquipData() {
      let that = this;
      if (this.EquipTimerCount++ > 20) {
        that.$message({
          type: "error",
          message: "获取对讲机设备信息超时",
        });
        this.EquipTimerCount = 0;
        clearInterval(this.EquipDataTimer);
        return;
      }
      let subscribersArray = WebSocketApi.GetAllSubscribers();
      if (subscribersArray != undefined && subscribersArray.length > 0) {
        /*console.log("subscribersArray",subscribersArray);*/
        this.StatisticsUser(subscribersArray);
        subscribersArray.forEach((item) => {
          item.Type = WebSocketApi.GetMemberTypeByNum(item.Type);
        });
        that.tableData = subscribersArray;
        that.tableData.map((item) => {
          item.userName = item.Name;
          item.dictAppType = item.Type;
        });
        this.EquipTimerCount = 0;
        clearInterval(this.EquipDataTimer);
      }
    },
    StatisticsUser() {
      let mapE = {};
      this.subscribersArray.forEach((element) => {
        mapE[element.Number] = element;
      });
      let Devices = [];
      this.userStateArray = WebSocketApi.GetAllUserState();

      for (let userNumber in this.userStateArray) {
        if (mapE[userNumber] && this.userStateArray[userNumber].Status != 0) {
          Devices.push(userNumber);
        }
      }

      this.realtimeData = [
        {
          name: "通讯设备",
          total: this.subscribersArray.length,
        },
        {
          name: "在线",
          total: Devices.length,
        },
      ];
    },
    searchGroupData() {
      WebSocketApi.SendAllSubscriberGroups();
    },
    searchPttGroupList() {
      WebSocketApi.SendGetPttGroupList();
    },
    OnReqMsg() {
      return WebSocketApi.GetErrorMsg();
    },
    OnReqRunState() {
      return WebSocketApi.GetRunstate();
    },
    OnGetConnectCount() {
      return WebSocketApi.GetConnectCount();
    },
    //获取所有用户
    getAllSubscribers() {
      if (this.subscribersArray && this.subscribersArray.length > 0) {
        /*console.log("subscribersArray",subscribersArray);*/
        //  this.StatisticsUser(subscribersArray);
        let mapE = {};
        this.subscribersArray.forEach((element) => {
          element.Type = WebSocketApi.GetMemberTypeByNum(element.Type);
          mapE[element.Number] = element;
        });
        this.StatisticsUser();
        //获取用户状态
        // let Devices = [];
        // this.userStateArray = WebSocketApi.GetAllUserState();

        // for (let userNumber in this.userStateArray) {
        //   if (mapE[userNumber]) {
        //     mapE[userNumber].Status = this.userStateArray[userNumber].Status;
        //     mapE[userNumber].StatusName =
        //       WebSocketApi.GetSubscriberStatusString(
        //         this.userStateArray[userNumber].Status
        //       );
        //     if (this.userStateArray[userNumber].Status != 0) {
        //       Devices.push(userNumber);
        //     }
        //   }
        // }

        this.tableData = this.subscribersArray;
        this.tableData.map((item) => {
          item.userName = item.Name;
          item.dictAppType = item.Type;
        });
      }
    },
    /*/获取用户组下的子组*/
    getChildGroups(parentGrp) {
      var childs = parentGrp.GroupChilds;
      if (typeof childs != "undefined") {
        for (var i = 0; i < childs.length; i++) {
          var obj = childs[i];
          var dept = {};
          dept.GroupName = obj.GroupName;
          dept.GroupMembers = obj.GroupMembers;
          dept.ParentGroup = parentGrp.GroupName;
          this.deptArray.push(dept);

          this.getChildGroups(obj);
        }
      }
    },
  },
  beforeDestroy() {},
  destroyed() {
    //移除监听器
    window.removeEventListener("onmessageWS", this.getSocketData);
  },
};
</script>
<style lang="scss" scoped>
div.flowCircleOne {
  padding-top: 5%;
}

.table_box {
  height: 90%;
  overflow: auto;
  margin-top: 30px;
}
</style>